import { getAllElementsWithAttr, getElementWithAttr, iframeURL, setStyleAttribute } from '../misc'
import { errorManyForms, errorManyTuringSpots, errorNoTuringSpot, Mode, ModeType, TuringAttr } from '../types'
import { ModalWindow } from './modal'
import createIFrame from './iframe'

export default class View {
  modalWindow: ModalWindow
  mode: ModeType

  turingSpot: HTMLElement
  wrapperElement: HTMLElement
  iframeElement: HTMLIFrameElement | null

  constructor() {
    this.modalWindow = new ModalWindow()
    this.mode = View.detectMode()
    this.iframeElement = null

    if (this.mode === Mode.Modal) {
      this.wrapperElement = document.body.appendChild(this.modalWindow.wrapper)
      this.turingSpot = this.modalWindow.window
    } else {
      const turingSpot = getElementWithAttr(TuringAttr.Spot)
      if (turingSpot === null) {
        throw errorNoTuringSpot(`cannot find element with '${TuringAttr.Spot}' attribute`)
      }

      this.turingSpot = turingSpot
      this.wrapperElement = turingSpot
    }
  }

  static detectMode(): ModeType {
    const turingSpot = getAllElementsWithAttr(TuringAttr.Spot)

    if (turingSpot.length === 0) {
      // Modal mode, should be only single form
      if (document.forms.length > 1) {
        throw errorManyForms('too many forms on the page')
      }
      return Mode.Modal
    } else {
      if (turingSpot.length > 1) {
        throw errorManyTuringSpots(`multiple elements with '${TuringAttr.Spot}' attribute`)
      }
      return Mode.WithHandler
    }
  }

  show(endpoint: string, challengeType: string, publicKey: string, sessionId: string): void {
    if (this.mode == Mode.Modal) {
      this.modalWindow.show()
    }
    if (this.iframeElement === null) {
      this.iframeElement = createIFrame(iframeURL(endpoint, challengeType), publicKey, sessionId)
      this.turingSpot.appendChild(this.iframeElement)
    }
  }

  hide(): void {
    if (this.mode === Mode.Modal) {
      this.modalWindow.hide()
    } else {
      setStyleAttribute(this.wrapperElement, { display: 'none' })
    }
  }

  clear(): void {
    this.modalWindow.remove()
    if (this.iframeElement !== null) {
      this.iframeElement.remove()
    }
  }
}
